import { EventEmitter, Injectable } from '@angular/core'
import { INotifyUserEventModel } from "./notify-user-event.model"


@Injectable({
  providedIn: 'root',
})
export class NotifyUserService {

  private _notifyEvent: EventEmitter<INotifyUserEventModel> = new EventEmitter<INotifyUserEventModel>()

  public get notifyEvent(): EventEmitter<INotifyUserEventModel> {
    return this._notifyEvent
  }

  public notify(message: INotifyUserEventModel): void {
    this._notifyEvent.next(message)
  }
}
